exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__user-card-avatar___nzuqP{position:absolute;display:flex;flex:0 0 auto;height:6rem;width:6rem;top:calc(50% - 3rem);left:calc(50% - 3rem);background-size:cover;background-repeat:no-repeat;background-position:50%;border-radius:100%;z-index:10}", ""]);

// exports
exports.locals = {
	"user-card-avatar": "styles__user-card-avatar___nzuqP"
};